import hyperdom from 'hyperdom'
import pluralize from 'pluralize'
import titlecase from 'title-case'
import formatRelativePrice from './packages/ui-helpers/formatRelativePrice.js'
import roomTypes from 'root-packages/accommodation/roomTypes.js'
import {isMultiShare} from 'root-packages/accommodation/sharedRoomsUtils.js'
import * as gtmDataLayer from './analytics/gtm/dataLayer.js'
import renderTooltip from './tooltip.jsx'
import RoomGraphics from './components/roomGraphics.jsx'

export default class RoomOptions {
  constructor (options) {
    this.binding = hyperdom.binding(options.binding),
    this.quoteCriteria = options.quoteCriteria
    this.currency = options.currency
    this.showMoreRoomOptions = false
    this.config = options.config
    if (this.quoteCriteria.roomAllocations) {
      var currentRoomAllocation = this.binding.get()

      if (this.quoteCriteria.roomAllocations.indexOf(currentRoomAllocation) == -1) {
        this.binding.set(this.quoteCriteria.roomAllocations[0])
      }
    }
  }

  onadd () {
    gtmDataLayer.activateOptimize()
  }

  onupdate () {
    gtmDataLayer.activateOptimize()
  }

  renderRoomTooltip (roomType) {
    const tooltipContent = this.config.roomOptionTooltip[roomType]

    if (!tooltipContent) {
      return
    }

    const calculatePositionCallback = (target) => {
      const parent = document.querySelector('.room-option-item')
      const parentWidth = parent.offsetWidth
      const parentStyle = getComputedStyle(parent)
      const parentBorderWidth = +parentStyle.getPropertyValue('border-width').split('px')[0]
      const parentPaddingWidth = +parentStyle.getPropertyValue('padding-left').split('px')[0]

      target.style.width = `${parentWidth}px`
      target.style.left = `-${parentBorderWidth + parentPaddingWidth}px`
    }

    return renderTooltip({
      content: tooltipContent,
      config: this.config,
      calculatePositionCallback,
    })
  }

  renderRoomAllocation (roomAllocation, recommended) {
    var selected = roomAllocation == this.binding.get()
    var self = this
    const selectedRoomPrice = self.quoteCriteria.roomAllocations.find((roomAllocation) => roomAllocation == this.binding.get()).price
    const priceToDisplay = selected ? roomAllocation.price : selectedRoomPrice - roomAllocation.price

    function reduceRoomsToUniqueByTypeAndOccupancy (uniqueRooms, room) {

      var existing = uniqueRooms.filter(r => r.roomType == room.roomType && r.adults === room.adults && r.children === room.children)[0]
      if (existing) {
        existing.count += room.count
      } else {
        uniqueRooms.push({
          name: roomTypes.displayNameForName(room.roomType),
          roomType: room.roomType,
          count: room.count,
          adults: room.adults,
          children: room.children,
          occupants: room.adults + room.children,
          share: room.share,
          maxPassengers: room.maxPassengers,
        })
      }
      return uniqueRooms
    }

    const isSoldOut = roomAllocation.status === 'closed'

    const ribbon = isSoldOut
      ? 'Sold Out'
      : recommended
        ? 'Recommended' : ''

    return <label class={{'o-choice-item': true, 'room-option-item': true, isSelected: isSoldOut ? false : selected, 'isSoldOut': isSoldOut}}>
      {
        ribbon
          ? <span class='ribbon -right room-option-item__ribbon'>{ribbon}</span>
          : undefined
      }
      <input type='radio' class='o-choice-item__radio' name='selector' binding={this.binding} value={roomAllocation} disabled={isSoldOut}/>
      <div class='o-choice-item__content'>

        <div class='room-option-item__details'>
          <div class='room-option-item__rooms'>
            {
              roomAllocation.rooms.reduce(reduceRoomsToUniqueByTypeAndOccupancy, []).map(function (room) {
                const isMultiShareRoomType = isMultiShare(room.roomType)
                const showMultishareCounter = isMultiShareRoomType && room.count >= 2
                let passengersInRoomMsg = `${room.adults} x ${pluralize('adult', room.adults)}`
                if (room.children) {
                  passengersInRoomMsg += `\n${room.children} x ${pluralize('child', room.children)}`
                }
                const roomGraphics  = new RoomGraphics({room, content: passengersInRoomMsg})
                return <div class={`room-unit ${isMultiShareRoomType ? 'room-unit-multi-share' : ''} ${showMultishareCounter ? 'show-multishare-counter' : ''}`}>
                  <div class="room-counter">
                    {self.renderRoomAllocationName(room)}
                    {self.renderRoomTooltip(room.roomType)}
                  </div>
                  <div style="flex: 1"></div>
                  {roomGraphics}
                </div>
              })
            }
          </div>
          <div class='room-option-item__price'>
            <strong className={['room-price',{'plus': !selected && priceToDisplay < 0, 'minus': !selected && priceToDisplay > 0}]}>
              {
                selected ? '' : formatRelativePrice({
                  currency: this.currency,
                  amount: priceToDisplay,
                  noPrefixSymbol: selected,
                })
              }
            </strong>
          </div>
        </div>
      </div>
    </label>
  }

  renderRoomAllocationName (room) {
    const roomCount = room.count > 1 ? `${room.count} x ` : ''
    const roomName = titlecase(`${room.name} room`)
    return <span className='room-counter__name'>{`${roomCount}${roomName}`}</span>
  }

  toggleMoreRoomOptions () {
    this.showMoreRoomOptions = !this.showMoreRoomOptions
  }

  render () {
    return <div class='room-options'>
      {
        this.quoteCriteria.roomAllocations.slice(0, 3).map((roomAllocation, index) => {
          return this.renderRoomAllocation(roomAllocation, index == 0)
        })
      }
      {
        this.quoteCriteria.roomAllocations.length > 3
          ? <div class='more-options' data-test='more-room-options'>
            <a href='#' onclick={(e) => { e.preventDefault(); this.toggleMoreRoomOptions() }}>
              {this.showMoreRoomOptions ? 'Hide' : 'Show'} more options
            </a>
          </div>
          : undefined
      }

      {
        this.showMoreRoomOptions
          ? this.quoteCriteria.roomAllocations.slice(3).map(roomAllocation => {
            return this.renderRoomAllocation(roomAllocation)
          })
          : undefined
      }
    </div>
  }
}